import {Action} from '@ngrx/store';
import {Country} from '../models/country';
import {type} from '../utilities/type';

export const countriesActionTypes = {
  LOAD: type('[Countries] Load'),
  LOAD_SUCCESS: type('[Countries] Load Success'),
  LOAD_FAIL: type('[Countries] Load Fail')
};

export class LoadCountriesAction implements Action {
  readonly type = countriesActionTypes.LOAD;
  constructor() {}
}

export class LoadCountriesSuccessAction implements Action {
  readonly type = countriesActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Country[]) {}
}

export class LoadCountriesFailAction implements Action {
  readonly type = countriesActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
